<footer class="bg-light mt-auto" [class.full-view-footer]="!hideSideBar">
    <div class="legal-line d-flex align-items-center justify-content-between">
        <div class="copy-right" *ngIf="isUserLoggedIn && businessName != undefined && businessName?.length > 0">
            <span class="company-name" appEllipsifyMe>{{isIndividualUser ? userName : businessName}}</span>
            <img src="../../../../assets/images/powered-by-Agenzee.svg"/>
            <!-- <span class="author-name"> - Powered by Agenzee</span>   -->
        </div>
        <div class="copy-right ml-auto">
            <span>© {{currentYear}}  Agenzee, LLC All rights reserved.</span>
            <a target="_blank" href="https://agenzee.com/privacy-policy/" class="privacy">Privacy Policy</a>
            <a target="_blank" href="https://agenzee.com/terms-conditions/" class="privacy">Terms & Conditions</a>
            <a target="_blank" href="https://agenzee.com/fcra/" class="privacy">FCRA</a>     
        </div>
        <!-- <div class="clear"></div> -->
    </div>
</footer>